module.exports = __webpack_public_path__ + "static/51-f0ed35bed7fa4c729f98ee4d981254af.png";